import { Checkbox, Dialog, Typography } from "@mui/material";
import RouteIcon from "@mui/icons-material/Route";

import React, { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import CustomButton from "../../../reusableComponents/CustomButton";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";

function ToggleRuleStatusModal({ data, setRuleData, isOpen, setIsOpen }) {
  const [loader, setLoader] = useState(false);
  const [ruleStatus, setRuleStatus] = useState("");
  const { updateRoutingRuleStatus } = useAuth();
  const handleKeyDownFallback = (event) => {
    if (event.key === "Escape") {
      setIsOpen(false);
    }
  };

  const handleChangeStatus = async () => {
    try {
      setLoader(true);
      await updateRoutingRuleStatus(
        data.ruleId,
        ruleStatus,
        (data) => {
          setRuleData((state) =>
            state.map((el) => {
              if (el.ruleId == data.ruleId) {
                return data;
              }
              return el;
            })
          );
          setIsOpen(false);
        },
        (errMsg) => {
          customToast("error", "high", errMsg || "Something Went Wrong");
        }
      );
      setLoader(false);
    } catch (err) {
      setLoader(false);
      customToast("error", "high", "Something Went Wrong");
    }
  };

  useEffect(() => {
    if (data?.status?.toLowerCase() == "disabled") {
      setRuleStatus("ACTIVE");
    } else {
      setRuleStatus("DISABLED");
    }
  }, []);

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          maxWidth: "700px",
          width: "700px",
        },
      }}
      onKeyDown={handleKeyDownFallback}
    >
      <div className="">
        <div
          className="d-flex align-items-start w-100 justify-content-between"
          style={{ padding: "24px 24px 0px 24px" }}
        >
          <div
            className="d-flex align-items-start  justify-content-start"
            style={{ gap: 10 }}
          >
            <RouteIcon />
            <Typography
              sx={{
                color: "#1D1C20",
                fontWeight: 600,
              }}
            >
              {ruleStatus?.toLowerCase() == "disabled"
                ? "Disable this rule for future transactions?"
                : "Activate this rule?"}
            </Typography>
          </div>
          <Close
            style={{ cursor: "pointer" }}
            onClick={() => setIsOpen(false)}
          />
        </div>
        <hr />

        <div className="px-4">
          <div className="mt-4 d-flex align-items-center">
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#2D2B32",
                letterSpacing: "-0.2px",
              }}
            >
              {ruleStatus?.toLowerCase() == "disabled"
                ? "This rule will be disabled for all future transactions until activated again."
                : "This rule will be activated for all future transactions"}
            </Typography>
          </div>
        </div>
      </div>

      <div className="modalBottomBar mt-4" style={{ boxShadow: "0 -15px 28px -15px rgba(39, 39, 39, 0.15)" }}>
        <CustomButton
          text={"Cancel"}
          onClick={() => setIsOpen(false)}
          variant={"outlined"}
          type={"secondary"}
          disabled={loader}
        />
        <CustomButton
          text={
            ruleStatus?.toLowerCase() == "disabled"
              ? "Disable Rule"
              : "Activate Rule"
          }
          loading={loader}
          onClick={handleChangeStatus}
          variant={"contained"}
          type={"secondary"}
        />
      </div>
    </Dialog>
  );
}

export default ToggleRuleStatusModal;
